export default async function loadWidget(widgetId) {

    // Для продакшн используем widgetmarket.ru/?id=1
    // Для дев нужно использовать свою дев тачку(поэтому добавляем хитрость, получаем с входного параметра)
    let url = import.meta.env.VITE_WM_API_URL;
    if (!url) {
        // use production
        url = 'https://widgetmarket.ru';
    }

    if (!widgetId) {
        widgetId = import.meta.env.VITE_WM_DEFAULT_WIDGET_ID;
    }

    try {
        const res = await fetch(`${url}/?id=${widgetId}`);
        return await res.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};